import { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import colors from "../../utils/style/colors.tsx";
import { HashLink } from "react-router-hash-link";
import { handleScroll } from "../../assets/js/custom.js";
import IconGame from "../../assets/images/icons/svgGame.svg";
import IconCode from "../../assets/images/icons/svgCode.svg";
import IconPro from "../../assets/images/icons/svgPro.svg";
import { SousTitre, MiniTexte } from "../../utils/style/elements.tsx";
import { LanguageContext } from "../../context/LanguageContext";
import navTrad from "../../traductions/nav-trad.js";

const NavAccueilWrapper = styled.nav`
    border: solid 10px black;
    height: fit-content;
    margin-top: 1.5rem;
    width: ${(props) => props.width}; 
    position: ${(props) => (props.$fixed ? "fixed" : "absolute")};
    top: ${(props) => (props.$fixed ? "-5px" : "auto")};
    transition: width 0.3s ease, top 0.3s ease; 

    @media (max-width: 768px) {
        display: none;
    }
`;

const NavHeader = styled.div`
    color: ${colors.white};
    background-color: ${colors.black};
    text-align: center;
    height: 52.8px;
`;

const StyledSousTitle = styled(SousTitre)`
    margin: 0;
    padding-top: 1rem;
    padding-bottom: 0.8rem;
`;

const CloseButton = styled.button`
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    border: unset;
    background: unset;
    color: ${colors.white};
    font-size: 20px;
    font-weight: 600;
`;

const StyledHashLink = styled(HashLink)`
    color: ${colors.red};
    text-decoration: none;
    font-size: 20px;
    font-family: "Archivo Black", sans-serif;
    display: flex;
    transition: all 0.5s ease;
    font-weight: 600;
    align-items: center;

    p {
        margin: 0;
    }
`;

const IconNav = styled.img`
    padding: 10px;
`;

function Nav({ onToggle }) {
    const [isFixed, setIsFixed] = useState(false);
    const [navWidth, setNavWidth] = useState("200px");
    const [showText, setShowText] = useState(true);
    const { language } = useContext(LanguageContext);
    

    useEffect(() => {
        const cleanup = handleScroll(setIsFixed);
        return cleanup;
    }, []);

    const isCollapsed = navWidth === "54px";

    const handleToggleNav = () => {
        const newWidth = isCollapsed ? "200px" : "54px";
        setNavWidth(newWidth);

        if (newWidth === "200px") {
            setTimeout(() => setShowText(true), 150);
        } else {
            setShowText(false);
        }

        onToggle(!isCollapsed);
    };

    return (
        <NavAccueilWrapper $fixed={isFixed} width={navWidth}>
            <NavHeader>
                {showText && !isCollapsed && <StyledSousTitle>{navTrad[language].titre}</StyledSousTitle>}
                
                {isCollapsed && (
                    <StyledSousTitle onClick={handleToggleNav} style={{ cursor: "pointer" }}>
                        &gt;&gt;&gt;
                    </StyledSousTitle>
                )}

                {showText && !isCollapsed && <CloseButton onClick={handleToggleNav}>x</CloseButton>}
            </NavHeader>

            <StyledHashLink smooth to="/#games">
                <IconNav src={IconGame} alt="Game Icon" width="34px" height="24px" />
                {showText && !isCollapsed && <MiniTexte>{navTrad[language].games}</MiniTexte>}
            </StyledHashLink>

            <StyledHashLink smooth to="/#pros">
                <IconNav src={IconPro} alt="Pro Icon" width="34px" height="28px" />
                {showText && !isCollapsed && <MiniTexte>{navTrad[language].pro}</MiniTexte>}
            </StyledHashLink>
            
            <StyledHashLink smooth to="/#codes">
                <IconNav src={IconCode} alt="Code Icon" width="34px" height="27px" />
                {showText && !isCollapsed && <MiniTexte>{navTrad[language].code}</MiniTexte>}
            </StyledHashLink>

        </NavAccueilWrapper>
    );
}

export default Nav;
